<template>
    <div
        class="modal fade"
        id="addEvaluationModal"
        tabindex="-1"
        aria-labelledby="addEvaluationModalLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <form action="" id="evaluation_form" @submit.prevent="formController()">
                    <div class="modal-header">
                        <h5 class="modal-title" id="addEvaluationModalLabel">
                            Valorar Servicio - Nº {{ order_number }}
                        </h5>
                        <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div class="modal-body">
                        <input type="hidden" :value="order_header_id" />
                        <div
                            class="input-box"
                            v-for="parameter in evaluationParameters"
                            v-bind:key="parameter.name"
                        >
                            <label>
                                {{ parameter.label }}
                                <span
                                    tabindex="0"
                                    data-bs-toggle="popover"
                                    data-bs-trigger="hover focus"
                                    :data-bs-content="parameter.info"
                                >
                                    <svg
                                        version="1.1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlns:xlink="http://www.w3.org/1999/xlink"
                                        x="0px"
                                        y="0px"
                                        width="512px"
                                        height="512px"
                                        viewBox="0 0 512 512"
                                        style="enable-background: new 0 0 512 512"
                                        xml:space="preserve"
                                    >
                                        <g>
                                            <g>
                                                <path
                                                    d="M256,0C114.51,0,0,114.5,0,256c0,141.49,114.5,256,256,256c141.49,0,256-114.5,256-256C512,114.51,397.5,0,256,0z M282.29,357.62c0,8.09-11.79,16.17-26.28,16.17c-15.16,0-25.95-8.09-25.95-16.17V229.23c0-9.43,10.78-15.84,25.95-15.84 c14.49,0,26.28,6.4,26.28,15.84V357.62z M256.01,182.4c-15.5,0-27.63-11.46-27.63-24.26c0-12.8,12.13-23.93,27.63-23.93 c15.16,0,27.3,11.12,27.3,23.93C283.3,170.94,271.17,182.4,256.01,182.4z"
                                                />
                                            </g>
                                        </g>
                                    </svg>
                                </span>
                            </label>
                            <div class="input-box__stars">
                                <template
                                    v-for="(n, index, loop = 5) in parameter.stars"
                                    v-bind:key="n"
                                >
                                    <input
                                        type="radio"
                                        :name="parameter.name"
                                        :id="parameter.name + (loop - index)"
                                        :value="loop - index"
                                    />
                                    <label :for="parameter.name + (loop - index)" class="star-fill">
                                        <svg
                                            version="1.1"
                                            xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink"
                                            x="0px"
                                            y="0px"
                                            width="47.94px"
                                            height="45.85px"
                                            viewBox="0 0 47.94 45.85"
                                            style="enable-background: new 0 0 47.94 45.85"
                                            xml:space="preserve"
                                        >
                                            <path
                                                class="st0"
                                                d="M26.28,1.44l5.41,10.96c0.38,0.76,1.1,1.29,1.94,1.41l12.09,1.76c2.12,0.31,2.96,2.91,1.43,4.4l-8.75,8.53 c-0.61,0.59-0.89,1.45-0.74,2.28l2.06,12.04c0.36,2.11-1.85,3.72-3.75,2.72l-10.81-5.69c-0.75-0.4-1.65-0.4-2.4,0l-10.81,5.69 c-1.89,1-4.11-0.61-3.75-2.72l2.06-12.04c0.14-0.84-0.13-1.69-0.74-2.28l-8.75-8.53c-1.53-1.49-0.69-4.1,1.43-4.4l12.09-1.76 c0.84-0.12,1.57-0.65,1.94-1.41l5.41-10.96C22.6-0.48,25.34-0.48,26.28,1.44z"
                                            />
                                        </svg>
                                    </label>
                                </template>
                            </div>
                        </div>
                        <div class="input-box input-box__textarea">
                            <label>Comentario</label>
                            <textarea name="comment" id="comment" cols="30" rows="10"></textarea>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn--outline" data-bs-dismiss="modal">
                            Cancelar
                        </button>
                        <button type="submit" class="btn btn--green">Registrar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import { inject, watchEffect } from 'vue'
import { customAlert } from '../../../general/js/utils/swalMessages'
export default {
    props: {
        url_detail: {
            type: String,
            default: '',
        },
        url_store: {
            type: String,
            default: '',
        },
        order_header_id: {
            type: [String, Number],
            default: '',
        },
        order_number: {
            type: String,
            default: '',
        },
    },
    setup(props, { emit }) {
        const loading = inject('loading')

        const evaluationParameters = [
            {
                name: 'appointment',
                label: 'Agendamiento de Citas',
                stars: 5,
                info: 'Fácil. Amigable. ¿Cumplieron con atenderlo?',
            },
            {
                name: 'treatment',
                label: 'Trato',
                stars: 5,
                info: 'Cordial y personalizado. Entienden los problemas planteados. Aclaran y confirman sus requerimientos. Tienen consideración con su tiempo. Lo valoran como cliente.',
            },
            {
                name: 'information',
                label: 'Información',
                stars: 5,
                info: 'Explican los trabajos realizados. Explican los costos.',
            },
            {
                name: 'parts',
                label: 'Repuestos',
                stars: 5,
                info: 'Disponibiliidad. Precio.',
            },
            {
                name: 'price',
                label: 'Precio',
                stars: 5,
                info: 'Precio justo. Respetan los precios.',
            },
            {
                name: 'payment_process',
                label: 'Proceso de pago',
                stars: 5,
                info: 'Fácil. Amigable.',
            },
            {
                name: 'quality_service',
                label: 'Calidad del servicio',
                stars: 5,
                info: 'Mecánicos competentes. Minuciosos en los trabajos. Prontitud en tener el auto listo. Condición del auto en la entrega.',
            },
            {
                name: 'facilities',
                label: 'Instalaciones',
                stars: 5,
                info: 'Limpieza. Orden.',
            },
        ]

        const formController = async () => {
            try {
                const form_id = document.getElementById('evaluation_form')
                const formData = new FormData(form_id)
                formData.append('order_header_id', props.order_header_id)

                const { data } = await axios.request({
                    url: props.url_store,
                    method: 'POST',
                    data: formData,
                })

                if (data.type == 1) {
                    closeModal()
                    emit('refresh-table')
                }

                customAlert(data)
            } catch (error) {
                console.error(error)
            }
        }

        const closeModal = () => {
            $('#addEvaluationModal').modal('hide')
            emit('close-modal')
        }

        return {
            evaluationParameters,
            closeModal,
            formController,
        }
    },
}
</script>
